/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Waveform } from '@audio-network/componentlibrary'
import { useWaveform } from '@audio-network/player'

import styles from './TrackWaveform.module.css'
import { TrackWaveformProps } from './TrackWaveform.types'

const TrackWaveform = ({ track }: TrackWaveformProps): JSX.Element => {
	const { ref, ...waveformProps } = useWaveform(track, {
		location: 'Track Row',
	})

	/** Add mousedown and mouseup events to static element (waveform div) to prevent dragging the track when trying to scrub */
	const handleMouseDown = (event: React.MouseEvent<HTMLDivElement>): void => {
		const draggable = event.currentTarget.closest('[draggable]')

		draggable.setAttribute('draggable', 'false')
	}

	const handleMouseUp = (event: React.MouseEvent<HTMLDivElement>): void => {
		const draggable = event.currentTarget.closest('[draggable]')

		draggable.setAttribute('draggable', 'true')

		/** Focus play button to mimic selecting existing playback functionality */
		const activeElement = document.activeElement

		if (activeElement instanceof HTMLInputElement) {
			const playButton = activeElement
				.closest('article')
				?.querySelector('button') as HTMLButtonElement | null

			if (playButton) {
				playButton.focus()
			}
		}
	}

	return (
		<div
			className={styles.waveform}
			onMouseDown={handleMouseDown}
			onMouseUp={handleMouseUp}
		>
			<Waveform ref={ref} {...waveformProps} highlights={track.highlights} />
		</div>
	)
}

export default TrackWaveform
